import { Injectable, EventEmitter } from '@angular/core';
import { EndUserSalesType } from '../models/end-user-sales-type';

@Injectable()
export class WatcherService {

    reloadQuoteDetail: EventEmitter<EndUserSalesType> = new EventEmitter();

    constructor() { }
}
